import { EmptyState, PageHeader } from '../../shared/console'
import { IconClock } from '../../shared/console/icons'
import { navLabel } from '../../app/router/nav'
import type { ConsoleScreenProps } from './types'

/**
 * A route whose redesigned screen has not landed yet. It says so plainly —
 * a screen of invented numbers would be worse than this.
 */
export function PendingScreen({ routeId, lang }: ConsoleScreenProps) {
  const title = navLabel(routeId, lang, routeId)
  return (
    <>
      <PageHeader title={title} />
      <div className="rounded-lg border border-line bg-surface shadow-card">
        <EmptyState icon={IconClock} title={`${title} is being built`} body="This screen is part of the console redesign and arrives in this release." />
      </div>
    </>
  )
}
